// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { classApi as ClassApi } from "../../Constant";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

// Define a service using a base URL and expected endpoints
export const classApi = createApi({
  reducerPath: "classApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  //baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_LOCAL_URL }),
  tagTypes: ["getClassList", "classDetail", "classDoubts", "getCalenderList"],
  endpoints: (builder) => ({
    getClassList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getClassList"],
    }),
    getCalenderList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getCalenderList"],
    }),
    getCalenderDetail: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getCalenderList"],
    }),
    getClassDoubts: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["classDoubts"],
    }),

    getMembers: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),

    getClassDetail: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["classDetail"],
    }),
    getClassAnalytic: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["classAnalytics"],
    }),

    deleteContext: builder.mutation({
      query: ({ endpoint }) => ({
        url: endpoint,
        method: "DELETE",
      }),
    }),

    linkClass: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "POST",
        body: updatedData,
      }),
      invalidatesTags: ["getClassList"],
    }),

    updateClass: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "PATCH",
        body: updatedData,
        headers: {
          "content-type": "application/json",
        },
      }),
      invalidatesTags: ["classDetail"],
    }),

    createClass: builder.mutation({
      query: ({ endpoint, newClass }) => ({
        url: endpoint,
        method: "POST",
        body: newClass,
      }),
      invalidatesTags: ["getClassList"],
    }),

    createConcept: builder.mutation({
      query: ({ endpoint, newData }) => ({
        url: endpoint,
        method: "POST",
        body: newData,
      }),
    }),
    createPractice: builder.mutation({
      query: ({ endpoint, newData }) => ({
        url: endpoint,
        method: "POST",
        body: newData,
      }),
    }),
    updateContext: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "PATCH",
        body: updatedData,
        headers: {
          "content-type": "application/json",
        },
      }),
      // invalidatesTags: ["classDetail"],
    }),


    statusClass: builder.mutation({
      query: ({ isPublished, classId }) => {

        return {
          url: `${ClassApi.endPoint}/status/${classId}`,
          method: 'PATCH',
          body: {
            isPublished
          },

        };
      },
    }),
    getClassCalendar: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
    //  getClassCalendarDetails: builder.query({
    //   query: (endpoint) => `${endpoint}`,
    // }),
    getClassCalendarDetails: builder.query({
      query: ({ id, classType }) => `exams/v1/classes/${id}?classType=${classType}`,
    }),

    addTemplates: builder.mutation({
      query: ({ endpoint, payload }) => ({
        url: endpoint,
        method: "POST",
        body: payload,
      }),
    }),
    updateTemplates: builder.mutation({
      query: ({ endpoint, payload }) => ({
        url: endpoint,
        method: "PATCH",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetClassListQuery,
  useGetClassDetailQuery,
  useGetClassCalendarQuery,
  useGetClassCalendarDetailsQuery,
  useLazyGetClassCalendarDetailsQuery,
  useLazyGetClassDetailQuery,
  useLinkClassMutation,
  useCreateClassMutation,
  useUpdateClassMutation,
  useGetMembersQuery,
  useGetClassDoubtsQuery,
  useCreateConceptMutation,
  useCreatePracticeMutation,
  useDeleteContextMutation,
  useUpdateContextMutation,
  useAddTemplatesMutation,
  useUpdateTemplatesMutation,
  useGetCalenderListQuery,
  useLazyGetCalenderDetailQuery,
  useGetClassAnalyticQuery,
  useStatusClassMutation
} = classApi;